module.exports = __webpack_public_path__ + "img/IMG-20200519-WA0005.93bb20ad.jpg";